import { render, staticRenderFns } from "./NewsTrend.vue?vue&type=template&id=fecc5e66"
import script from "./NewsTrend.vue?vue&type=script&lang=js"
export * from "./NewsTrend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports